import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0417b3be"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "M-Auto DialogContainer" }
const _hoisted_3 = {
  class: "DialogBody",
  style: {"max-width":"none"}
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "D-Flex W-100",
  style: {"text-align":"left","margin-bottom":"15px","white-space":"nowrap"}
}, null, -1))
const _hoisted_5 = {
  key: 2,
  class: "DialogSection",
  style: {"flex-direction":"row"}
}
const _hoisted_6 = {
  key: 3,
  class: "DialogSection",
  style: {"flex-direction":"row"}
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "CookiesRowSpacer" }, null, -1))
const _hoisted_8 = {
  key: 4,
  class: "DialogSection",
  style: {"flex-direction":"row"}
}
const _hoisted_9 = {
  key: 5,
  class: "DialogSection"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "CookiesRowSplitter" }, null, -1))
const _hoisted_11 = { class: "DialogSectionTitle" }
const _hoisted_12 = { class: "DialogSection" }
const _hoisted_13 = { class: "ItemSelector" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { class: "ItemContent" }
const _hoisted_16 = { class: "F-Bold F1_5em" }
const _hoisted_17 = { class: "F-Bold" }
const _hoisted_18 = { class: "O-50" }
const _hoisted_19 = { class: "F-Bold" }
const _hoisted_20 = { class: "O-50" }
const _hoisted_21 = { class: "F-Bold" }
const _hoisted_22 = { class: "O-50" }
const _hoisted_23 = {
  key: 0,
  class: "F-Bold"
}
const _hoisted_24 = { class: "O-50" }
const _hoisted_25 = { key: 0 }
const _hoisted_26 = {
  key: 1,
  class: "F-Bold F1_25em",
  style: {"color":"var(--colorr1)"}
}
const _hoisted_27 = { class: "O-50" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "AddButton" }, "+", -1))
const _hoisted_29 = { class: "CookiesRowSplitter P-Rel" }
const _hoisted_30 = {
  key: 0,
  style: {"bottom":"-3em"},
  class: "AddedItem Rad1 BGThird Shadow1"
}
const _hoisted_31 = { class: "Color2 F1_25em" }
const _hoisted_32 = { class: "DialogSectionTitle" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "scrollpoint",
  class: "CookiesRowSplitter"
}, null, -1))
const _hoisted_34 = { class: "DialogSection" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "CookiesRowSpacer" }, null, -1))
const _hoisted_36 = {
  key: 0,
  class: "CookiesDialogFooter"
}
const _hoisted_37 = {
  class: "F-Bold",
  style: {"margin":"auto 1em"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DialogDisabler = _resolveComponent("DialogDisabler")!
  const _component_CookiesIcon = _resolveComponent("CookiesIcon")!
  const _component_CookiesDropInputObject = _resolveComponent("CookiesDropInputObject")!
  const _component_CookiesNormalInput = _resolveComponent("CookiesNormalInput")!
  const _component_CookiesDropDown = _resolveComponent("CookiesDropDown")!
  const _component_CookiesSearchInput = _resolveComponent("CookiesSearchInput")!
  const _component_CookiesTable = _resolveComponent("CookiesTable")!
  const _component_CookiesDescriptionBox = _resolveComponent("CookiesDescriptionBox")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      id: 'CookiesDialog_' + _ctx.DialogIndex,
      class: "CookiesDialogdBody"
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          (_ctx.Saving)
            ? (_openBlock(), _createBlock(_component_DialogDisabler, {
                key: 0,
                class: "W-100 H-100"
              }))
            : _createCommentVNode("", true),
          (_ctx.Loading.length > 0)
            ? (_openBlock(), _createBlock(_component_DialogDisabler, {
                key: 1,
                class: "W-100 H-100"
              }))
            : _createCommentVNode("", true),
          _hoisted_4,
          (_ctx.DialogData.Type === 'Import' || _ctx.DialogData.Type === 'ExternalImport')
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createVNode(_component_CookiesIcon, {
                  class: "SQR2em F2em",
                  ID: ('ItemImport' as IconsIDs)
                }, null, 8, ["ID"])
              ]))
            : _createCommentVNode("", true),
          (_ctx.DialogData.Type === 'Export' || _ctx.DialogData.Type === 'BranchesTransfer')
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createVNode(_component_CookiesIcon, {
                  class: "SQR2em F2em",
                  ID: ('Export' as IconsIDs)
                }, null, 8, ["ID"])
              ]))
            : _createCommentVNode("", true),
          _hoisted_7,
          (_ctx.DialogData.Type === 'Import' || _ctx.DialogData.Type === 'ExternalImport')
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createVNode(_component_CookiesDropInputObject, {
                  CookiesInvalidInput: !_ctx.MEMRead('D_Transfers_ImportSource'),
                  ErrorData: _ctx.ErrorsVisibilty && !_ctx.MEMRead('D_Transfers_ImportSource'),
                  Name: _ctx.Translate('Source'),
                  Default: '',
                  Options: _ctx.TransferSources,
                  Selectors: ['Name'],
                  Res: 'D_Transfers_ImportSource'
                }, null, 8, ["CookiesInvalidInput", "ErrorData", "Name", "Options"]),
                _createVNode(_component_CookiesIcon, {
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.EditCategories('TransferSources', 'Sources'))),
                  class: "SQR2em V-Auto HoverGLow Pointer BlackWhite",
                  ToolTip: _ctx.Translate('Add new source'),
                  ID: ('Edited' as IconsIDs)
                }, null, 8, ["ToolTip", "ID"])
              ]))
            : _createCommentVNode("", true),
          (_ctx.DialogData.Type === 'BranchesTransfer')
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createVNode(_component_CookiesDropInputObject, {
                  CookiesInvalidInput: !_ctx.MEMRead('D_Transfers_DestinationBranch'),
                  ErrorData: _ctx.ErrorsVisibilty && !_ctx.MEMRead('D_Transfers_DestinationBranch'),
                  Name: _ctx.Translate('Branch'),
                  Options: _ctx.OtherBranches,
                  Selectors: ['Name'],
                  Res: 'D_Transfers_DestinationBranch'
                }, null, 8, ["CookiesInvalidInput", "ErrorData", "Name", "Options"])
              ]))
            : _createCommentVNode("", true),
          (_ctx.DialogData.Type === 'ExternalImport' && _ctx.DialogData.Editing)
            ? (_openBlock(), _createBlock(_component_CookiesNormalInput, {
                key: 6,
                type: 'number',
                CookiesInvalidInput: !_ctx.MEMRead('D_Transfer_TransferNO') || _ctx.MEMRead('D_Transfer_TransferNO') === '',
                ErrorData: _ctx.ErrorsVisibilty && !_ctx.MEMRead('D_Transfer_TransferNO') || _ctx.MEMRead('D_Transfer_TransferNO') === '',
                Placeholder: _ctx.Translate('No.'),
                Res: 'D_Transfer_TransferNO'
              }, null, 8, ["CookiesInvalidInput", "ErrorData", "Placeholder"]))
            : _createCommentVNode("", true),
          (_ctx.DialogData.Type === 'Export')
            ? (_openBlock(), _createBlock(_component_CookiesNormalInput, {
                key: 7,
                CookiesInvalidInput: !_ctx.MEMRead('D_Transfer_Customer'),
                ErrorData: _ctx.ErrorsVisibilty && !_ctx.MEMRead('D_Transfer_Customer'),
                Placeholder: _ctx.Translate('Customer Name'),
                Res: 'D_Transfer_Customer'
              }, null, 8, ["CookiesInvalidInput", "ErrorData", "Placeholder"]))
            : _createCommentVNode("", true),
          (_ctx.DialogData.Type === 'Export')
            ? (_openBlock(), _createBlock(_component_CookiesNormalInput, {
                key: 8,
                Placeholder: _ctx.Translate('Customer Phone'),
                Res: 'D_Transfer_CustomerPhone'
              }, null, 8, ["Placeholder"]))
            : _createCommentVNode("", true),
          (_ctx.DialogData.Type === 'ExternalImport')
            ? (_openBlock(), _createBlock(_component_CookiesNormalInput, {
                key: 9,
                Placeholder: _ctx.Translate('Container Ship'),
                Res: 'D_Transfer_ContainerShip'
              }, null, 8, ["Placeholder"]))
            : _createCommentVNode("", true),
          _hoisted_10,
          _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.Translate('Select Items')), 1),
          _createElementVNode("div", _hoisted_12, [
            _createVNode(_component_CookiesDropDown, {
              Name: _ctx.Translate('Brand'),
              Width: '40%',
              style: {"max-width":"80%"},
              Res: 'D_Transfer_Brand',
              Options: _ctx.Brands,
              Type: 'Object',
              Selector: 'Name'
            }, null, 8, ["Name", "Options"]),
            _createVNode(_component_CookiesDropDown, {
              Name: _ctx.Translate('Category'),
              Width: '40%',
              style: {"max-width":"80%"},
              Res: 'D_Transfer_Category',
              Options: _ctx.Categories,
              Type: 'Object',
              Selector: 'Name'
            }, null, 8, ["Name", "Options"]),
            _createVNode(_component_CookiesSearchInput, {
              style: {"flex":"1"},
              Placeholder: _ctx.Translate('Code...'),
              Res: 'D_Transfer_SearchByCode'
            }, null, 8, ["Placeholder"]),
            _createVNode(_component_CookiesSearchInput, {
              style: {"flex":"3"},
              Placeholder: _ctx.Translate('Search...'),
              Res: 'D_Transfer_Search'
            }, null, 8, ["Placeholder"]),
            _createVNode(_component_CookiesIcon, {
              class: "SQR2em V-Auto",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.ReadDialogData())),
              ID: ('Delayed' as IconsIDs)
            }, null, 8, ["ID"]),
            _createElementVNode("div", _hoisted_13, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.FilteredItems, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  onClick: ($event: any) => (_ctx.CheckItem(item)),
                  key: index
                }, [
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, _toDisplayString(item.Code), 1),
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.CashedTranslations['Name']) + ":", 1),
                      _createTextVNode(),
                      _createElementVNode("span", null, _toDisplayString(item.Name), 1)
                    ]),
                    _createElementVNode("div", _hoisted_19, [
                      _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.CashedTranslations['Brand']) + ":", 1),
                      _createTextVNode(),
                      _createElementVNode("span", null, _toDisplayString(item.BrandName), 1)
                    ]),
                    _createElementVNode("div", _hoisted_21, [
                      _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.CashedTranslations['Category']) + ":", 1),
                      _createTextVNode(),
                      _createElementVNode("span", null, _toDisplayString(item.CategoryName), 1)
                    ]),
                    (_ctx.DialogData.Type === 'Export' || _ctx.DialogData.Type === 'BranchesTransfer')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                          _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.CashedTranslations['Available']) + ":", 1),
                          _createTextVNode(),
                          (item.AvailableQuantity > 0)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_25, _toDisplayString(_ctx.DecimalFixer(item.AvailableQuantity)), 1))
                            : (_openBlock(), _createElementBlock("span", _hoisted_26, _toDisplayString(_ctx.CashedTranslations['Not Available']), 1))
                        ]))
                      : _createCommentVNode("", true),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.Specifications, (spec) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "F-Bold",
                        key: spec
                      }, [
                        _createElementVNode("span", _hoisted_27, _toDisplayString(_ctx.Translate(spec.Name)) + ":", 1),
                        _createTextVNode(),
                        _createElementVNode("span", null, _toDisplayString(spec.Description), 1)
                      ]))
                    }), 128))
                  ]),
                  _hoisted_28
                ], 8, _hoisted_14))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_29, [
              (_ctx.AddedItem)
                ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                    _createElementVNode("span", _hoisted_31, "+" + _toDisplayString(_ctx.Translate('Added')), 1)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_32, _toDisplayString(_ctx.Translate('Selected Items')), 1),
            _createVNode(_component_CookiesTable, {
              onInputChanged: _ctx.SaveLocal,
              onFieldEdited: _ctx.SaveLocal,
              onChooseLocations: _ctx.ChooseLocations,
              onShowLocations: _ctx.ShowLocations,
              CookiesInvalidInput: _ctx.TransferItems.length < 1,
              ErrorData: _ctx.ErrorsVisibilty && _ctx.TransferItems.length < 1,
              onDeleteRow: _ctx.RemoveItem,
              class: "Shadow1",
              TableSettings: _ctx.TableSettings,
              CookiesData: _ctx.TransferItems,
              Search: '',
              Loading: (_ctx.Loading.length > 0),
              Saving: (_ctx.SavingTable.length > 0),
              Saved: _ctx.Saved
            }, null, 8, ["onInputChanged", "onFieldEdited", "onChooseLocations", "onShowLocations", "CookiesInvalidInput", "ErrorData", "onDeleteRow", "TableSettings", "CookiesData", "Loading", "Saving", "Saved"])
          ]),
          _hoisted_33,
          _createElementVNode("div", _hoisted_34, [
            _createVNode(_component_CookiesDescriptionBox, {
              Placeholder: _ctx.Translate('Note'),
              Res: 'D_Transfer_Note'
            }, null, 8, ["Placeholder"])
          ]),
          _hoisted_35
        ])
      ])
    ], 8, _hoisted_1),
    (_ctx.Access('Inventory_Transfers_Export') || _ctx.Access('Inventory_Transfers_Import') || _ctx.Access('Inventory_Transfers_Edit'))
      ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
          _createElementVNode("div", _hoisted_37, [
            _createElementVNode("button", {
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$router.go(-1))),
              style: {"background":"var(--colorr1)"},
              class: "F-Bold CookiesButton DialogFooterButton"
            }, _toDisplayString(_ctx.Translate('Close')), 1),
            _createElementVNode("button", {
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.SaveData && _ctx.SaveData(...args))),
              style: _normalizeStyle('background: ' + _ctx.Theme.UserColors.main),
              class: "F-Bold CookiesButton DialogFooterButton"
            }, _toDisplayString(_ctx.DialogData.Editing ? _ctx.Translate('Save') : _ctx.Translate('Add')), 5)
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}